import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ActivatePage from "@/pages/ActivatePage";
import TestDrivePage from "@/pages/TestDrivePage";
import ContactPage from "@/pages/ContactPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import DestinationsPage from "@/pages/DestinationsPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import { PortalActivatedPage, TestDriveThanksPage } from "@/pages/PostPurchasePages";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public site (under Layout with header/footer) */}
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/activate" element={<ActivatePage />} />
              <Route path="/test-drive" element={<TestDrivePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/destinations" element={<DestinationsPage />} />
              <Route path="/portal-activated" element={<PortalActivatedPage />} />
              <Route path="/test-drive-thanks" element={<TestDriveThanksPage />} />
            </Route>

            {/* Admin (no public header/footer) */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#1E293B",
              color: "#F8FAFC",
              border: "1px solid #334155",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
